import { useEffect, useState } from "react";

const initialState = {
    cantidadCuotas: "",
    primerVencimiento: "",
    montoPorCuota: "",
};

export default function GenerarCuotasForm({ deuda, onClose, onSave }) {
    const [form, setForm] = useState(initialState);

    useEffect(() => {
        const saldo = Number(deuda?.saldoPendiente || 0);
        setForm({
            cantidadCuotas: "",
            primerVencimiento: "",
            montoPorCuota: saldo > 0 ? saldo.toFixed(2) : "",
        });
    }, [deuda]);

    useEffect(() => {
        const cantidad = Number(form.cantidadCuotas || 0);
        const saldo = Number(deuda?.saldoPendiente || 0);

        if (cantidad > 0 && saldo > 0) {
            setForm((prev) => ({
                ...prev,
                montoPorCuota: (saldo / cantidad).toFixed(2),
            }));
        }
    }, [form.cantidadCuotas, deuda]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        await onSave({
            cantidadCuotas: Number(form.cantidadCuotas || 0),
            primerVencimiento: form.primerVencimiento,
            montoPorCuota: Number(form.montoPorCuota || 0),
        });
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-card">
                <div className="modal-header">
                    <h3>Generar cuotas: {deuda?.entidad}</h3>
                    <button type="button" onClick={onClose}>X</button>
                </div>

                <form className="grid-form" onSubmit={handleSubmit}>
                    <div>
                        <label>Cantidad de cuotas</label>
                        <input
                            name="cantidadCuotas"
                            type="number"
                            placeholder="Ej. 6"
                            value={form.cantidadCuotas}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Primer vencimiento</label>
                        <input
                            name="primerVencimiento"
                            type="date"
                            value={form.primerVencimiento}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Monto por cuota</label>
                        <input
                            name="montoPorCuota"
                            type="number"
                            step="0.01"
                            value={form.montoPorCuota}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-actions full-width">
                        <button type="button" onClick={onClose}>Cancelar</button>
                        <button type="submit">Generar cuotas</button>
                    </div>
                </form>
            </div>
        </div>
    );
}